/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WidgetBookEventResponse = {
    createdAt: string;
    id: number;
    locationSelection: WidgetBookEventResponse.locationSelection;
    isConfirmed: boolean;
    isOutage: boolean;
    ics: string;
    paymentStatus?: WidgetBookEventResponse.paymentStatus | null;
};
export namespace WidgetBookEventResponse {
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
        NOT_FIXED = 'not-fixed',
    }
    export enum paymentStatus {
        OPEN = 'open',
        PENDING = 'pending',
        PAID = 'paid',
        FAILED = 'failed',
        CANCELLED = 'cancelled',
        REFUNDED = 'refunded',
    }
}

